export default "__VITE_ASSET__CV0oRkjq__"